import LayoutView from "../components/layout/layout";
import NoLayoutView from "../components/layout/noLayout";
// --Modules--
// import { lazy } from "react";
import HomePage from "../pages/Dashboard";
import LoginPage from "../pages/Login";

// --- UserManagement ---
import UserPage from "../pages/UserManagement";
import UserCreateUpdatePage from "../pages/UserManagement/CreateOrUpdate";

// --- Parameter ---
import ParameterPage from "../pages/Parameter";
import ParameterCreateUpdatePage from "../pages/Parameter/CreateOrUpdate";

// --- WaterMonitoring ---
import WaterMonitoring from "../pages/WaterMonitoring";

// --- UserInfo ---
import UserInfo from "../pages/UserInfo";

// --- Roles ---
import RolesPage from "../pages/Roles";
import RolesCreateUpdatePage from "../pages/Roles/CreateOrUpdate";
import MapPage from "../pages/Map";

// --- Standard ---
import StandardPage from "../pages/Standard";
import StandardCreateUpdatePage from "../pages/Standard/CreateOrUpdate";
import StandardViewPage from "../pages/Standard/View";

// --- ParameterUnit ---
import ParameterUnitPage from "../pages/ParameterUnit";
import ParameterUnitCreateUpdatePage from "../pages/ParameterUnit/CreateOrUpdate";

// --- Station ---
import StationPage from "../pages/Station";
import StationCreateUpdatePage from "../pages/Station/CreateOrUpdate";
import StationViewPage from "../pages/Station/View";

// --- SamplingSchedule ---
import SamplingSchedulePage from "../pages/SamplingSchedule";
import SamplingScheduleCreateUpdatePage from "../pages/SamplingSchedule/CreateOrUpdate";

// --- Problem ---
import ProblemPage from "../pages/Problem";
import ProblemCreateUpdatePage from "../pages/Problem/CreateOrUpdate";
import ProblemViewPage from "../pages/Problem/view";

// --- StatisticData ---
import StatisticDataPage from "../pages/StatisticData";

// --- 404 ---
import NotFoundPage from "../pages/NotFound";

// --- UrlCollection ---
import { UrlCollection } from "../common/url-collection";
import StatisticMinMaxPage from "../pages/StatisticMinMax";
import StatisticNumberOfTimesExceededPage from "../pages/statisticNumberOfTimesExceeded";
import StatisticThresholdExceedancePage from "../pages/statisticThresholdExceedance";
import Register2FA from "../pages/Register2FA";

const routes = [
    {
        layout: LayoutView,
        component: HomePage,
        path: UrlCollection.Home,
        title: "sideBar.dashboard",
    },
    {
        layout: LayoutView,
        component: HomePage,
        path: UrlCollection.Dashboard,
        title: "sideBar.dashboard",
    },
    // --- Map ---
    {
        layout: LayoutView,
        component: MapPage,
        path: UrlCollection.Map,
        title: "sideBar.map",
    },
    // --- ParameterUnit ---
    {
        layout: LayoutView,
        component: ParameterUnitPage,
        path: UrlCollection.ParameterUnit,
        title: "sideBar.parameterUnit",
    },
    {
        layout: LayoutView,
        component: ParameterUnitCreateUpdatePage,
        path: UrlCollection.CreateParameterUnit,
        title: "sideBar.createParameterUnit",
    },
    {
        layout: LayoutView,
        component: ParameterUnitCreateUpdatePage,
        path: UrlCollection.EditParameterUnit,
        title: "sideBar.editParameterUnit",
    },
    // --- User ---
    {
        layout: LayoutView,
        component: UserInfo,
        path: UrlCollection.UserInfo,
        title: "sideBar.userInfo",
    },
    {
        layout: LayoutView,
        component: Register2FA,
        path: UrlCollection.Register2FA,
        title: "Đăng ký 2FA",
    },
    // --- Roles ---
    {
        layout: LayoutView,
        component: RolesPage,
        path: UrlCollection.Roles,
        title: "sideBar.roles",
    },
    {
        layout: LayoutView,
        component: RolesCreateUpdatePage,
        path: UrlCollection.CreateRole,
        title: "sideBar.createRole",
    },
    {
        layout: LayoutView,
        component: RolesCreateUpdatePage,
        path: UrlCollection.EditRole,
        title: "sideBar.editRole",
    },
    // --- Parameter ---
    {
        layout: LayoutView,
        component: ParameterPage,
        path: UrlCollection.Parameter,
        title: "sideBar.parameter",
    },
    {
        layout: LayoutView,
        component: ParameterCreateUpdatePage,
        path: UrlCollection.CreateParameter,
        title: "sideBar.createParameter",
    },
    {
        layout: LayoutView,
        component: ParameterCreateUpdatePage,
        path: UrlCollection.EditParameter,
        title: "sideBar.editParameter",
    },
    // --- Standard ---
    {
        layout: LayoutView,
        component: StandardPage,
        path: UrlCollection.Standard,
        title: "sideBar.standard",
    },
    {
        layout: LayoutView,
        component: StandardCreateUpdatePage,
        path: UrlCollection.CreateStandard,
        title: "sideBar.createStandard",
    },
    {
        layout: LayoutView,
        component: StandardCreateUpdatePage,
        path: UrlCollection.EditStandard,
        title: "sideBar.editStandard",
    },
    {
        layout: LayoutView,
        component: StandardViewPage,
        path: UrlCollection.ViewStandard,
        title: "sideBar.viewStandard",
    },
    // --- Station ---
    {
        layout: LayoutView,
        component: StationPage,
        path: UrlCollection.Station,
        title: "sideBar.station",
    },
    {
        layout: LayoutView,
        component: StationCreateUpdatePage,
        path: UrlCollection.CreateStation,
        title: "sideBar.createStation",
    },
    {
        layout: LayoutView,
        component: StationCreateUpdatePage,
        path: UrlCollection.EditStation,
        title: "sideBar.editStation",
    },
    {
        layout: LayoutView,
        component: StationViewPage,
        path: UrlCollection.ViewStation,
        title: "sideBar.viewStation",
    },
    // --- SamplingSchedule ---
    {
        layout: LayoutView,
        component: SamplingSchedulePage,
        path: UrlCollection.SamplingSchedule,
        title: "sideBar.samplingSchedule",
    },
    {
        layout: LayoutView,
        component: SamplingScheduleCreateUpdatePage,
        path: UrlCollection.CreateSamplingSchedule,
        title: "sideBar.createSamplingSchedule",
    },
    {
        layout: LayoutView,
        component: SamplingScheduleCreateUpdatePage,
        path: UrlCollection.EditSamplingSchedule,
        title: "sideBar.editSamplingSchedule",
    },
    // --- Problem ---
    {
        layout: LayoutView,
        component: ProblemPage,
        path: UrlCollection.Problem,
        title: "sideBar.problem",
    },
    {
        layout: LayoutView,
        component: ProblemCreateUpdatePage,
        path: UrlCollection.CreateProblem,
        title: "sideBar.createProblem",
    },
    {
        layout: LayoutView,
        component: ProblemCreateUpdatePage,
        path: UrlCollection.EditProblem,
        title: "sideBar.editProblem",
    },
    {
        layout: LayoutView,
        component: ProblemViewPage,
        path: UrlCollection.ViewProblem,
        title: "sideBar.viewProblem",
    },
    // --- StatisticData ---
    {
        layout: LayoutView,
        component: StatisticDataPage,
        path: UrlCollection.StatisticData,
        title: "sideBar.statisticData",
    },
    {
        layout: LayoutView,
        component: StatisticMinMaxPage,
        path: UrlCollection.StatisticMinMaxData,
        title: "sideBar.statisticMinMaxData",
    },
    // --- StatisticThresholdExceedance ---
    {
        layout: LayoutView,
        component: StatisticThresholdExceedancePage,
        path: UrlCollection.StatisticThresholdExceedanceData,
        title: "sideBar.statisticThresholdExceedanceData",
    },
    // --- StatisticNumberOfTimesExceeded ---
    {
        layout: LayoutView,
        component: StatisticNumberOfTimesExceededPage,
        path: UrlCollection.StatisticNumberOfTimesExceededData,
        title: "sideBar.statisticNumberOfTimesExceededData",
    },
    // --- WaterMonitoring ---
    {
        layout: LayoutView,
        component: WaterMonitoring,
        path: UrlCollection.WaterMonitoring,
        title: "sideBar.waterMonitoring",
    },
    // --- UserManager ---
    {
        layout: LayoutView,
        component: UserPage,
        path: UrlCollection.UserManager,
        title: "sideBar.userManager",
    },
    {
        layout: LayoutView,
        component: UserCreateUpdatePage,
        path: UrlCollection.CreateUser,
        title: "sideBar.createUser",
    },
    {
        layout: LayoutView,
        component: UserCreateUpdatePage,
        path: UrlCollection.EditUser,
        title: "sideBar.editUser",
    },
    // --- ViewUser ---
    {
        layout: NoLayoutView,
        component: LoginPage,
        path: UrlCollection.Login,
        isSetActive: false,
    },
    // --- 404 ---
    {
        layout: NoLayoutView,
        component: NotFoundPage,
        path: "*",
        isSetActive: false,
    },
];

export default routes;